import Link from 'next/link'
import { useRouter } from 'next/router'

function ShouldLogin() {
    const router = useRouter()

    return (
        <div className="bg-red-100 border space-x-1 flex border-red-200 text-olm-black text-sm font-semibold py-2 my-1 px-2">
            <span>Please</span>
            <Link href={`/login?redirectTo=${router.asPath}`}>
                <a className="underline hover:no-underline">login </a>
            </Link>
            <span>to use this feature.</span>
        </div>
    )
}

export default ShouldLogin
